import EditBase from "../EditBase"

class EditCircle extends EditBase {

    constructor(options) {
        super(options);
    }

    checkRotatePoint() {
        return false;
    }

    initKeyPoint(){
        var keyPos = this.plot.attrPlot["edit_positions"]; //拿到关键点数组
        var e_pos = [];
        for (let i = 1; i < keyPos.length; i++) {
            var entity = this.createEnity();
            var point = this.createPoint(this.getDefaultStyle("point_Nor"));
            entity.show = false;
            entity.position = keyPos[i];
            entity.point = point;
            this.viewer.entities.add(entity);
            this.entities.push(entity);
            entity.attrPlot = {
                e_index: i,
                editGuid: this.editGuid,
                edit_keyFlag: true
            };
            e_pos.push(entity);
        }
        this.plot.attrPlot["edit_keyPos"] = e_pos; //实体
    }

    initCenterPoint(){
        var cartesian3=this.plot.attrPlot["edit_positions"][0];
        var entity = this.createEnity();
        var point = this.createPoint(this.getDefaultStyle("point_Center"));
        entity.show = false;
        entity.position = cartesian3;
        entity.point = point;
        entity.attrPlot = {
            editGuid: this.editGuid,
            edit_centerFlag: true
        };
        this.viewer.entities.add(entity);
        this.entities.push(entity);
        this.plot.attrPlot["edit_center"] = entity; //实体
        this.plot.attrPlot['center_cartesian3'] = cartesian3;
    }

    updateCenter(){

    }

    translateAll(position){
        super.translateAll(position);
        this.plot.position.setValue(position);
    }

    heightMoveAll(endPosition, startPosition) {
        var $this = this;
        var zOffset = new Cesium.Cartesian3();
        //改变高度垂直拖动
        var dy = endPosition.y - startPosition.y;

        var position = $this.heightPos.position.getValue();
        //获取该点的投影面
        var tangentPlane = new Cesium.EllipsoidTangentPlane(position);
        var scratchBoundingSphere = new Cesium.BoundingSphere(); //包围球体
        scratchBoundingSphere.center = position;
        scratchBoundingSphere.radius = 1;

        //获取像素大小-米
        var metersPerPixel = $this.viewer.scene.frameState.camera.getPixelSize(scratchBoundingSphere, $this.viewer.scene.frameState.context.drawingBufferWidth, $this.viewer.scene.frameState.context.drawingBufferHeight);
        var heightDiff = -dy * metersPerPixel;

        Cesium.Cartesian3.multiplyByScalar(tangentPlane.zAxis, heightDiff, zOffset);
        var newPosition = Cesium.Cartesian3.clone(position);
        Cesium.Cartesian3.add(position, zOffset, newPosition);

        //更新开始
        var oldHeight = $this.plot.ellipse.extrudedHeight || 0;
        $this.plot.ellipse.extrudedHeight = oldHeight + heightDiff;

        $this.heightPos.position.setValue(newPosition);
        $this.plot.attrPlot["edit_extrudedHeight"] = $this.plot.ellipse.extrudedHeight;

    }

    initProperty() {
        var $this = this;
        var minR = 1;
        var positions = [];
        var semiAxisProperty = new $this.Cesium.CallbackProperty(function () {
            positions = $this.plot.attrPlot["edit_positions"];
            var center = positions[0];
            var outline = positions[1];

            var r= Cesium.Cartesian3.distance(center, outline);
            return r ? r : r + minR;
        }, false);

        this.plot.ellipse.semiMinorAxis = semiAxisProperty;
        this.plot.ellipse.semiMajorAxis = semiAxisProperty;
    }
}

export default EditCircle;